import React, { FC } from "react";
import { BoxProps } from "types/RichMenu";
import { Box, FullWidthBox, BaseBoxContainer, Badge } from "./styled";

const FourBoxesFirstRowBigOne: FC<BoxProps> = ({ bgColor }) => {
  return (
    <BaseBoxContainer>
      <FullWidthBox bgColor={bgColor}>
        <Badge>A</Badge>
      </FullWidthBox>
      <Box bgColor={bgColor}>
        <Badge>B</Badge>
      </Box>
      <Box bgColor={bgColor}>
        <Badge>C</Badge>
      </Box>
      <Box bgColor={bgColor}>
        <Badge>D</Badge>
      </Box>
    </BaseBoxContainer>
  );
};

export default FourBoxesFirstRowBigOne;
